import * as React from 'react';
import SvgImage from '../SvgImage';
import './styles.scss';

interface ButtonProps {
  type: 'button' | 'submit' | 'reset';
  style?: 'default' | 'secondary' | 'transparent' | 'uci';
  text?: string;
  icon?: {
    reference: string;
    title: string;
  } | undefined;
  role?: 'button';
  ariaLabel?: string;
  disabled?: boolean;
  showLoader?: boolean;
  iconOnly?: boolean;
  fullWidth?: boolean;
  isProcessing?: boolean;
  handleClick?: (event: React.MouseEvent<HTMLButtonElement>) => void | undefined;
}

const Button = ({
  type = 'button',
  style = 'default',
  text,
  icon,
  ariaLabel,
  disabled = false,
  showLoader = false,
  iconOnly = false,
  fullWidth = false,
  isProcessing = false,
  handleClick,
}: ButtonProps) => {
  const buttonClass = `
    button
    button--${style}
    ${text && 'button--has-label'}
    ${icon && 'button--has-icon'}
    ${iconOnly && 'button--icon-only'}
    ${fullWidth && 'button--full-width'}
    ${showLoader && 'button--updating'}
    ${disabled && 'button--disabled'}
    ${isProcessing && 'button--processing'}
  `;

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={buttonClass}
    >
      {icon && (
        <div className="button__icon">
          <SvgImage {...icon} />
        </div>
      )}

      {text && (
        <div className="button__label">
          {text}
        </div>
      )}
    </button>
  );
};

export default Button;
